var FlightUpgradeService = /** @class */ (function () {
    function FlightUpgradeService(httpRequest) {
        this.httpRequest = httpRequest;
    }
    /**
     * Search Upgrade
     * This request will return the following response for an `ELIGIBLE/MODIFY/NOT_ELIGIBLE` response status. If the `responseStatus` is `ELIGIBLE or MODIFY`, then the `redirectUrl` will have a value and the page should be redirected to that url. If the `responseStatus` is `NOT_ELIGIBLE or any other response`, please show the modal with the error messages passed as props to the vue component.
   *
   * The Vue component should accept 2 props, one prop to accept the NOT_ELIGIBLE error message, and the 2nd prop should accept a `Not Found Error for any other response status`.
   *
   * ``` json
   * {
     * "status": 201,
     * "code": "",
     * "message": "Success",
     * "data": {
       * "responseStatus": "ELIGIBLE",
       * "redirectUrl": "https://upg.stage.plusgrade.com/offers/partner/602mlrQaKQ/Zkw9nIj4bQZzbwzt6P7uqK3n85G8nVoo1W"
       * },
       * "dictionaries": null
       * }
       *
       * ```
       *
       * if there was an error finding the record, then the responseStatus would be anything else besides `ELIGIBLE/MODIFY/NOT_ELIGIBLE`, eg. `PNR_NOT_FOUND` or if the data field in the json is null/empty, then the response would look like this:
       *
       * ``` json
       * {
         * "status": 412,
         * "code": "",
         * "message": "Error",
         * "data": {
           * "responseStatus": "PNR_NOT_FOUND",
           * "redirectUrl": null
           * },
           * "dictionaries": null
           * }
           *
           * ```
           *
           * If the above error is recieved the Record Not Found prop message passed through should be used.
     * @param pnr Required Parametyer from user input
     * @param lastName Required Parametyer from user input
     * @param isEconomyMax Optional Parameter if it's used as an economy max block
     * @returns any Successful response
     * @throws ApiError
     */
    FlightUpgradeService.prototype.getApiV1PlusGradeSearch = function (pnr, lastName, isEconomyMax) {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/plus-grade/search/{pnr}/{lastName}',
            path: {
                'pnr': pnr,
                'lastName': lastName,
            },
            query: {
                'isEconomyMax': isEconomyMax,
            },
        });
    };
    return FlightUpgradeService;
}());
export { FlightUpgradeService };
